import React from "react";
import {
  Grid,
  TextField,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const PlayersFilters = ({
  inputStyles,
  searchQuery,
  setSearchQuery,
  selectedLeague,
  setSelectedLeague,
  selectedTeam,
  setSelectedTeam,
  selectedPosition,
  setSelectedPosition,
  leagues,
  teams,
}) => {
  // Positions exactly as stored in the DB - this value goes straight onto the
  // request as ?position= and is matched raw, so "FWD" would never match.
  const positions = ["GK", "DEF", "MID", "STR"];

  return (
    <Grid container spacing={1} sx={{ mb: 3 }}>
      <Grid item xs={6} md={2}>
        <TextField
          fullWidth
          label="Search all players"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={inputStyles}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <TextField
          select
          fullWidth
          label="All Tournaments"
          value={selectedLeague}
          onChange={(e) => setSelectedLeague(e.target.value)}
          sx={inputStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDownIcon,
          }}
        >
          <MenuItem value="">All Tournaments</MenuItem>
          {leagues.map((league) => (
            <MenuItem key={league.id} value={league.id}>
              {league.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <TextField
          select
          fullWidth
          label="All Teams"
          value={selectedTeam}
          onChange={(e) => setSelectedTeam(e.target.value)}
          sx={inputStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDownIcon,
            MenuProps: {
              PaperProps: {
                style: {
                  maxHeight: 400,
                  maxWidth: 300,
                },
              },
            },
          }}
        >
          <MenuItem value="">All Teams</MenuItem>
          {teams.map((team) => (
            <MenuItem key={team.id} value={team.id}>
              {team.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6} md={1.5}>
        <TextField
          select
          fullWidth
          label="All Positions"
          value={selectedPosition}
          onChange={(e) => setSelectedPosition(e.target.value)}
          sx={inputStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDownIcon,
          }}
        >
          <MenuItem value="">All Positions</MenuItem>
          {positions.map((position) => (
            <MenuItem key={position} value={position}>
              {position}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
};

export default PlayersFilters;
